// 流股说明
export const streamDesc: Record<string, string> = {
  "31-89": "甲醇分离进料，至B1",
  "31-901": "甲醇分离进料，至P-109",
  "31-891": "来自B1，待分离的甲醇和水，至T-106塔",
  "31-90": "来自P-109，待分离的甲醇和水，至T-106塔",
  "31-95": "来自换热单元冷流股出口，至T-106塔",
  "31-99o": "T-106塔塔顶出料",
  "31-91": "T-106塔塔底废水，作为换热单元的热流股入口",
  "31-60": "尾气洗涤单元气相进料，至B6",
  "31-100": "尾气洗涤单元气相进料，至B6",
  "31-60100": "来自B6混流后的进料，至B7",
  "31-6010A": "来自B7分流后的气相进料，至T-109A塔",
  "31-6010B": "来自B7分流后的气相进料，至T-109B塔",
  "31-94A": "T-109A塔洗涤水进料，至T-109A塔",
  "31-94B": "T-109B塔洗涤水进料，至T-109B塔",
  "31-94AS11": "来自B12混流后的洗涤水进料，至T-109A塔",
  "31-94BS12": "来自B13混流后的洗涤水进料，至T-109B塔",
  S1: "换热单元冷流股出口，至B14",
  S6: "来自B11，换热单元的冷流股入口",
  S11: "来自B14分流后的废水，至B12",
  S12: "来自B14分流后的废水，至B13",
  S2: "来自T-109A塔底采出，至B11",
  S5: "来自T-109B塔底采出，至B11",
  IMPURE: "来自B14分流后废水，直接排放",
  "31-61A": "来自T-109A塔塔顶出料",
  "31-61B": "来自T-109B塔塔顶出料",
  "31-95A": "来自T-109A塔塔底出料，至P-110",
  "31-95B": "来自T-109B塔塔底出料，至P-111",
};

// 单元操作说明
export const elementDesc: Record<string, string> = {
  B1: "泵",
  "P-109": "泵",
  "T-106": "精馏塔",
  "E128-A": "板式换热器",
  "P-110": "泵",
  "P-111": "泵",
  B14: "分流器",
  B7: "分流器",
  B6: "混合器",
  B11: "混合器",
  B12: "混合器",
  B13: "混合器",
  "T-109A": "洗涤塔A",
  "T-109B": "洗涤塔B",
};

// 参数字段说明：
export const fieldDesc: Record<string, string> = {
  physical_method: "物性计算方法",
  mode: "计算模式",
  phase: "相态",

  N: "塔板数",
  Ns: "进料位置",
  No: "出料位置",
  f: "流量",
  t: "温度",
  P_D: "塔顶压力",
  pressure_drop: "整塔压降",
  SPEC: "冷凝器类型",
  eff: "塔板效率",
  murphree: "是否使用Murphree效率",
  T_drop: "顶板过冷度",
  S1: "塔顶流股名称规定方式",
  S2: "规定方式 2",
  V1: "塔釜采出量",
  V2: "规定值 2",
  V_list: "气相采出信息列表",
  L_list: "液相采出信息列表",
  Q_list: "中段加热/冷却热量信息列表",
  max_iter_outer: "最大外层迭代次数",
  max_notimproved_count: "最大未改进迭代次数",
  max_inner_notconverged_count: "最大内层未收敛迭代次数",
  TOL: "收敛容差",
  im_mode: "稳健性策略编号",
  h: "时间松弛因子",
  D_col: "塔径",
  theta: "有效孔面积比",
  h_w: "堰高",
  C_v: "孔流系数",
  d_hole: "孔径",
  efficiency: "效率",
  hot_out_T: "热流股出口温度",
  UA: "传热系数和换热面积的乘积",
  output_f: "输出流量",
  deltaP: "压力变化",
  p: "入口压力",
  flow_type: "流向类型",
};

// 参数点位map
export const pointsMap = [
  {
    name: "31-94A",
    code: "FC0314",
    type: 'streams',
    field: "f",
    desc: "31-94A 洗涤水流量",
    selected: true,
  },
  {
    name: "31-94A",
    code: "TI0327",
    type: 'streams',
    field: "t",
    desc: "31-94A 洗涤水温度",
    selected: true,
  },
  {
    name: "31-94B",
    code: "FC0324",
    type: 'streams',
    field: "f",
    desc: "31-94B 洗涤水流量",
    selected: true,
  },
  {
    name: "31-94B",
    code: "TI0337",
    type: 'streams',
    field: "t",
    desc: "31-94B 洗涤水温度",
    selected: true,
  },
  {
    name: "31-89",
    code: "FC0310",
    type: 'streams',
    field: "f",
    desc: "31-89 进料流量",
    selected: false,
  },
  {
    name: "31-901",
    code: "FC0311",
    type: 'streams',
    field: "f",
    desc: "31-901 进料流量",
    selected: false,
  },
  {
    name: "T-106",
    code: "10306",
    type: 'elements',
    field: "pressure_drop",
    desc: "T-106 压降",
    selected: false,
  },
  {
    name: "T-106",
    code: "PI0306A",
    type: 'elements',
    field: "P_D",
    desc: "T-106 塔顶压力",
    selected: false,
  },
  {
    name: "T-109A",
    code: "PD10307",
    type: 'elements',
    field: "pressure_drop",
    desc: "T-109A 压降",
    selected: true,
  },
  {
    name: "T-109B",
    code: "PD10317",
    type: 'elements',
    field: "pressure_drop",
    desc: "T-109B 压降",
    selected: true,
  },
]

// type中文名（查看计算参数用）
export const typeMap: Record<string, string> =
{
  "Flash2": "闪蒸罐",
  "Mixer": "混合器",
  "Splitter": "分流器",
  "RPlugReactor": "反应器",
  "ShellAndTubeExchanger": "管壳式换热器",
  "Pump": "泵",
  "DistilShortCut": "精馏塔简捷模型",
  "DistilStrict": "精馏塔严格模型",
};

// 查看计算参数所需字段信息（查看计算参数用）
export const fieldMap =
{
  elements:
  {
    // "name":{name:"操作单元名称",enum:{},unit:"",unitKey:""},
    // "type":{name:"操作单元类型",enum:{},unit:"",unitKey:""},
    "physical_method": { name: "物性计算方法", enum: { "NRTL": "NRTL", "SRK": "SRK" }, unit: "", unitKey: "" },
    "phase": { name: "相态", enum: { "L": "L-液相", "V": "V-汽相", "VL": "VL-汽液两相" }, unit: "", unitKey: "" },
    "mode": { name: "计算模式", enum: { "TP": "TP-温压闪蒸", "VP": "VP-汽化率压力闪蒸", "HP": "HP-压焓闪蒸" }, unit: "", unitKey: "" },
    "deltaP": { name: "压力变化", enum: {}, unit: "", unitKey: "" },
    "N": { name: "塔板数", enum: {}, unit: "", unitKey: "" },
    "P_D": { name: "塔顶压力", enum: {}, unit: "", unitKey: "p_unit" },
    "pressure_drop": { name: "整塔压降", enum: {}, unit: "", unitKey: "p_unit" },
    "SPEC": { name: "冷凝器类型", enum: { "Partial": "分凝器", "Total": "全凝器" }, unit: "", unitKey: "" },
    // "murphree":{name:"是否使用Murphree效率",enum:{0:"不使用",1:"使用"},unit:"",unitKey:""},
    // "T_drop":{name:"顶板过冷度",enum:{},unit:"",unitKey:""},
    // "S1":{name:"塔顶流股名称规定方式",enum:{"B":"塔底流量"},unit:"",unitKey:""},
    // "S2":{name:"规定方式",enum:{"L/D":"回流比","QC":"冷凝器热负荷"},unit:"",unitKey:""},
    "V1": { name: "塔釜采出量", enum: {}, unit: "", unitKey: "V1_unit" },
    "V2": { name: "冷凝器热负荷", enum: {}, unit: "", unitKey: "" }, //S2="L/D"=回流比;S2="QC"=冷凝器热负荷 J/mol
    "D_col": { name: "塔径", enum: {}, unit: "m", unitKey: "" },
    "theta": { name: "有效孔面积比", enum: {}, unit: "", unitKey: "" },
    "h_w": { name: "堰高", enum: {}, unit: "m", unitKey: "" },
    "C_v": { name: "孔流系数", enum: {}, unit: "", unitKey: "" },
    "d_hole": { name: "孔径", enum: {}, unit: "m", unitKey: "" },
    "UA": { name: "传热系数和换热面积的乘积", enum: {}, unit: "W/K", unitKey: "" },
    "flow_type": { name: "流向类型", enum: {}, unit: "", unitKey: "" },
    "efficiency": { name: "热效率", enum: {}, unit: "", unitKey: "" },
    "hot_out_T": { name: "热流出口温度", enum: {}, unit: "", unitKey: "t_unit" },
    //以下3个为后添加，单位可能不对
    "hot_out_P": { name: "热流出口压力", enum: {}, unit: "", unitKey: "p_unit" },
    "cold_out_T": { name: "冷流出口温度", enum: {}, unit: "", unitKey: "t_unit" },
    "cold_out_P": { name: "冷流出口压力", enum: {}, unit: "", unitKey: "p_unit" },
    "f": { name: "流量", enum: {}, unit: "", unitKey: "f_unit" },
    "t": { name: "温度", enum: {}, unit: "", unitKey: "t_unit" },
    "p": { name: "压力", enum: {}, unit: "", unitKey: "p_unit" },
  },
  streams:
  {
    "physical_method": { name: "物性计算方法", enum: { "NRTL": "NRTL", "SRK": "SRK" }, unit: "", unitKey: "" },
    "mode": { name: "计算模式", enum: { "TP": "TP-温压闪蒸", "VP": "VP-汽化率压力闪蒸", "HP": "HP-压焓闪蒸" }, unit: "", unitKey: "" },
    "phase": { name: "相态", enum: { "L": "L-液相", "V": "V-汽相", "VL": "VL-汽液两相" }, unit: "", unitKey: "" },
    "f": { name: "流量", enum: {}, unit: "", unitKey: "f_unit" },
    "t": { name: "温度", enum: {}, unit: "", unitKey: "t_unit" },
    "p": { name: "压力", enum: {}, unit: "", unitKey: "p_unit" },
  }
};

export function convertStreamsToDescMap(streams: any[]) {
  if (!streams || !Array.isArray(streams)) return {};

  return streams.reduce((map, stream) => {
    const name = stream?.name?.trim();
    const desc = stream?.description?.trim() || '-';
    
    if (name) {
      map[name] = desc;
    }
    return map;
  }, {} as Record<string, string>);
}
